import { getResourceFromCms } from '@namespace/helpers';
import { validateScheme } from '@namespace/helpers/src/utils/validateSchema';
import { PromotionsApi } from '../../store/types';
import { PromotionsSchema } from './schemas';
import { Logger } from './types';

export const getPromotions = async (options?: {
  isSSR: boolean;
  headers: Record<string, string>;
  logger: Logger;
}): Promise<PromotionsApi> => {
  const response = await getResourceFromCms('/promotions', options);

  if (Array.isArray(response)) {
    validateScheme(PromotionsSchema, response, { name: 'getPromotions' });
    return response;
  }

  throw new Error('Invalid response format for promotions');
};
